// extracted by mini-css-extract-plugin
module.exports = {"tags":"_1jcKT"};